import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';

const logOrderEvent = (event)=>{
    DataLayer.pushEvent(swcHelpers.objectSpread({
        event: event.event
    }, 'atfEcommerce' in event ? {
        atfEcommerce: event.atfEcommerce
    } : null, 'events' in event ? {
        events: event.events
    } : null, 'event_type' in event ? {
        event_type: event.event_type
    } : null, 'order' in event ? {
        order: event.order
    } : null));
};

export { logOrderEvent };
//# sourceMappingURL=orders.js.map
